import React, { useState } from 'react'
import { Avatar, Box, Button, Divider, IconButton, MenuItem, Modal, Popover, Stack, Typography } from '@mui/material'
import { useAuth } from '../../../hooks/useAuth'
import { useTranslation } from 'react-i18next'
import { storageUserGet } from 'storage/storageUser'
import { User } from 'contexts/AuthContext'
import { getFirstLetter } from 'utils'
import { deepOrange } from '@mui/material/colors'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../redux/hooks'
import { selectedProfessional } from '../../../redux/reducers/profile/profile.selectors'
import ContactUs from './ContactUs'
import Iconify from '../../../components/Iconify'

export default function AccountPopover () {
  const navigate = useNavigate()
  const { signOut } = useAuth()
  const { t } = useTranslation()
  const [user] = useState<User | null>(storageUserGet())
  const [open, setOpen] = useState(null)
  const [openContactModal, setOpenContactModal] = useState(false)
  const profile = useAppSelector(selectedProfessional)

  const goToProfile = () => {
    navigate('/profile')
    handleClose()
  }

  const goToContact = () => {
    setOpenContactModal(true)
    handleClose()
  }

  const handleOpen = (event: any) => {
    setOpen(event.currentTarget)
  }

  const handleClose = () => {
    setOpen(null)
  }

  const handleContactModalClose = () => {
    setOpenContactModal(false)
  }

  return <>
    <IconButton
      onClick={handleOpen}
      sx={{
        p: 0,
        ...(typeof open && {
          '&:before': {
            zIndex: 1,
            content: "''",
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            position: 'absolute'
          }
        })
      }}
    >
      {profile?.imagePath
        ? <Avatar src={profile?.imagePath} alt="photoURL" sx={{ width: 45, height: 45 }}/>
        : <Avatar sx={{ bgcolor: 'rgb(250, 89, 62, 0.1)', width: 45, height: 45, fontWeight: 'bold', zIndex: 1 }}>
          <Typography component="h1" variant="h3" sx={{ color: deepOrange[500], zIndex: 9 }}>
            {user?.name ? getFirstLetter(user?.name) : ''}
          </Typography>
        </Avatar>
      }
    </IconButton>

    <Popover
      open={Boolean(open)}
      anchorEl={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 0,
          mt: 1.5,
          ml: 0.75,
          minWidth: 180,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75
          }
        }
      }}
    >
      <Box sx={{ my: 1.5, px: 2.5 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {user?.email}
        </Typography>
      </Box>

      <MenuItem onClick={goToProfile} sx={{ m: 1 }}>
        Meu Perfil
      </MenuItem>

      <MenuItem onClick={goToContact} sx={{ m: 1 }}>
        {t('contact.title')}
      </MenuItem>

      <Divider sx={{ borderStyle: 'dashed' }}/>

      <MenuItem onClick={signOut} sx={{ m: 1 }}>
        {t('header.menu.logout')}
      </MenuItem>
    </Popover>
    <Modal
      open={openContactModal}
      onClose={handleContactModalClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Stack direction="column">
        <Stack alignItems="end">
          <Button variant="text" onClick={handleContactModalClose}>
            <Iconify icon="material-symbols:close" width={35} height={35}/>
          </Button>
        </Stack>
        <ContactUs />
      </Stack>
    </Modal>
  </>
}
